/**
 * Cover Image Credit - Progressive Enhancement
 *
 * Parses alt text on cover images and media-text images.
 * If the alt contains a line break (\n), the first line is kept as the alt text
 * and the remaining lines become an expandable credit caption.
 *
 * The caption is collapsed by default, showing "Credit". Clicking expands it
 * to reveal the full credit text. Positioned bottom-right of the container.
 */

(function () {
	'use strict';

	const SELECTORS = [
		{
			selector: '.wp-block-cover > .wp-block-cover__image-background',
			container: '.wp-block-cover',
		},
		{ selector: '.wp-block-media-text__media > img', container: '.wp-block-media-text__media' },
	];

	var ICON_EXPAND =
		'<svg class="cover-image-credit__icon cover-image-credit__icon--expand" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M11 21V13H3V11H11V3H13V11H21V13H13V21H11Z" fill="white"/></svg>';
	var ICON_COLLAPSE =
		'<svg class="cover-image-credit__icon cover-image-credit__icon--collapse" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M5 13V11H19V13H5Z" fill="white"/></svg>';

	function init() {
		SELECTORS.forEach(function (config) {
			var elements = document.querySelectorAll(config.selector);
			elements.forEach(function (el) {
				processImage(el, config.container);
			});
		});
	}

	/**
	 * Process a single image for credit extraction
	 * @param {HTMLElement} el - Could be an <img> or a <picture> wrapping an <img>
	 * @param {string} containerSelector - CSS selector for the parent container
	 */
	function processImage(el, containerSelector) {
		// The matched element might be a <picture> wrapping the <img>,
		// so we need to find the actual <img> with the alt text
		var img = el.tagName === 'IMG' ? el : el.querySelector('img');

		if (!img) return;

		const alt = img.getAttribute('alt');

		if (!alt || !alt.includes('\n')) return;

		const lines = alt
			.split('\n')
			.map(function (line) {
				return line.trim();
			})
			.filter(Boolean);

		if (lines.length < 2) return;

		// First line stays as the alt
		const cleanAlt = lines[0];
		// Everything else is the credit
		const creditText = lines.slice(1).join(' ');

		// Update the alt to only the first line
		img.setAttribute('alt', cleanAlt);

		// Build the credit element
		var container = img.closest(containerSelector);
		if (!container) return;

		var creditId = 'cover-credit-' + Math.random().toString(36).substr(2, 9);

		// Create the wrapper
		var wrapper = document.createElement('figure');
		wrapper.className = 'cover-image-credit';

		// Create the toggle button
		var button = document.createElement('button');
		button.type = 'button';
		button.className = 'cover-image-credit__toggle';
		button.setAttribute('aria-expanded', 'false');
		button.setAttribute('aria-controls', creditId);
		button.innerHTML = 'Credit ' + ICON_EXPAND + ICON_COLLAPSE;

		// Create the caption
		var caption = document.createElement('figcaption');
		caption.className = 'cover-image-credit__caption';
		caption.id = creditId;
		caption.setAttribute('aria-hidden', 'true');
		caption.textContent = creditText;

		wrapper.appendChild(caption);
		wrapper.appendChild(button);

		// Ensure the container has relative positioning
		container.style.position = container.style.position || 'relative';

		// Append to the container
		container.appendChild(wrapper);

		// Toggle handler
		button.addEventListener('click', function () {
			var isExpanded = button.getAttribute('aria-expanded') === 'true';
			var newState = !isExpanded;

			button.setAttribute('aria-expanded', String(newState));
			caption.setAttribute('aria-hidden', String(!newState));
			wrapper.classList.toggle('is-expanded', newState);
		});
	}

	// Initialize when DOM is ready
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
